<template>
	<div>
		<div v-if="loading">
			<loader></loader>
		</div>
		<div id="canvas">
			<img class="previous-page" src="../../img/left.svg" value="previous" @click="pagePrev" />
			<img class="next-page" src="../../img/right.svg" value="next" @click="pageNext" />
			<div class="flipbook-viewport">
				<div class="col-auto float-left bar">
					<router-link style="padding-right: 70px" to="/home">Kiosk</router-link>
					<a to v-if="!index" @click="cambiarEstado('/index')">Index</a>
					<a to="/index" v-else @click="cambiarEstado('')">Close</a>
				</div>
				<div class="col-auto float-right bar">
					<a class="zoom-icon zoom-icon-in">Fullscreen</a>
				</div>
				<div class="container">
					<div class="flipbook" id="btnClick" @keyup.right="pause" @keyup.left="pause" @click.prevent="pause">
						<div :style="'background-image:url(' + pages9[0] + ')'"></div>
						<div :style="'background-image:url(' + pages9[1] + ')'"></div>
						<div :style="'background-image:url(' + pages9[2] + ')'"></div>
						<div :style="'background-image:url(' + pages9[3] + ')'"></div>
						<div :style="'background-image:url(' + pages9[4] + ')'"></div>
						<div :style="'background-image:url(' + pages9[5] + ')'"></div>
						<div :style="'background-image:url(' + pages9[6] + ')'"></div>
						<div :style="'background-image:url(' + pages9[7] + ')'"></div>
						<div :style="'background-image:url(' + pages9[8] + ')'"></div>
						<div :style="'background-image:url(' + pages9[9] + ')'"></div>
						<div :style="'background-image:url(' + pages9[10] + ')'"></div>
						<div :style="'background-image:url(' + pages9[11] + ')'"></div>
						<div :style="'background-image:url(' + pages9[12] + ')'"></div>
						<div :style="'background-image:url(' + pages9[13] + ')'"></div>
						<div :style="'background-image:url(' + pages9[14] + ')'"></div>
						<div :style="'background-image:url(' + pages9[15] + ')'"></div>
						<div :style="'background-image:url(' + pages9[16] + ')'"></div>
						<div :style="'background-image:url(' + pages9[17] + ')'"></div>
						<div :style="'background-image:url(' + pages9[18] + ')'"></div>
						<div :style="'background-image:url(' + pages9[19] + ')'"></div>
						<div :style="'background-image:url(' + pages9[20] + ')'"></div>
						<div :style="'background-image:url(' + pages9[21] + ')'"></div>
						<div :style="'background-image:url(' + pages9[22] + ')'"></div>
						<div :style="'background-image:url(' + pages9[23] + ')'"></div>
						<div :style="'background-image:url(' + pages9[24] + ')'"></div>
						<div :style="'background-image:url(' + pages9[25] + ')'"></div>
						<div :style="'background-image:url(' + pages9[26] + ')'"></div>
						<div :style="'background-image:url(' + pages9[27] + ')'"></div>
						<div :style="'background-image:url(' + pages9[28] + ')'">
							<a class="minilinks articles2" style="bottom: 9.2%; left: 31%; width: 6%;" target="_blank"	@click="openLink('https://fpm.climatepartner.com/tracking/13766-2304-1002/en?utm_source=climatepartner.com&utm_medium=id')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[29] + ')'"></div>
						<div :style="'background-image:url(' + pages9[30] + ')'"></div>
						<div :style="'background-image:url(' + pages9[31] + ')'"></div>
						<div :style="'background-image:url(' + pages9[32] + ')'"></div>
						<div :style="'background-image:url(' + pages9[33] + ')'"></div>
						<div :style="'background-image:url(' + pages9[34] + ')'">
							<a class="minilinks articles2" style="bottom: 23.6%; right: 37.5%; width: 11.4%;" target="_blank"	@click="openLink('https://instagram.com/amanyaruri')">clik</a>
						</div>     
						<div :style="'background-image:url(' + pages9[35] + ')'">
							<a class="minilinks articles2" style="bottom: 22.9%; left: 38.5%; width: 10.2%" target="_blank"	@click="openLink('https://isseymiyake.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 77%; left: 60.6%; width: 6%" target="_blank"	@click="openLink('https://clhu.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 85.8%; right: 13%; width: 7%" target="_blank"	@click="openLink('https://us.jins.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 7.2%; left: 38%; width: 15%" target="_blank"	@click="openLink('https://orangeculture.com.ng')">clik</a>
							<a class="minilinks articles2" style="bottom: 43.9%; right: 24.8%; width: 14%" target="_blank"	@click="openLink('https://anothertomorrow.co')">clik</a>
							<a class="minilinks articles2" style="bottom: 87.4%; left: 26.4%; width: 13.2%" target="_blank"	@click="openLink('https://fmillerskincare.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 56.1%; left: 8.2%; width: 11.4%" target="_blank"	@click="openLink('https://saltandstone.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 31.6%; right: 9.4%; width: 14.5%" target="_blank"	@click="openLink('https://bitetoothpastebits.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 7.2%; left: 7.2%; width: 12.8%" target="_blank"	@click="openLink('https://livecostabrazil.com')">clik</a>						
						</div>
						<div :style="'background-image:url(' + pages9[36] + ')'">
							<a class="minilinks articles2" style="bottom: 75.2%; left: 47.8%; width: 11.6%" target="_blank"	@click="openLink('https://wearechance.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 76.9%; right: 16%; width: 9.6%" target="_blank"	@click="openLink('https://dick-moby.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 16%; left: 29.5%; width: 14%" target="_blank"	@click="openLink('https://studionicholson.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5.6%; left: 37.8%; width: 12.4%" target="_blank"	@click="openLink('https://lauralombardi.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 7.2%; right: 18.5%; width: 12%" target="_blank"	@click="openLink('https://collinastrada.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 63%; left: 12%; width: 12.8%" target="_blank"	@click="openLink('https://palladiumboots.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 80.4%; left: 20%; width: 10.5%" target="_blank"	@click="openLink('https://everybody.world')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[37] + ')'">
							<a class="minilinks articles2" style="bottom: 12.7%; left: 31.5%; width: 12.2%" target="_blank"	@click="openLink('https://www.instagram.com/poloralphlauren/')">clik</a>							
						</div>
						<div :style="'background-image:url(' + pages9[38] + ')'"></div>
						<div :style="'background-image:url(' + pages9[39] + ')'"></div>
						<div :style="'background-image:url(' + pages9[40] + ')'">							
							<a class="minilinks articles2" style="bottom: 21.6%; right: 5%; width: 9.4%" target="_blank"	@click="openLink('https://instagram.com/tiffanyandco')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[41] + ')'">							
							<a class="minilinks articles2" style="bottom: 18.8%; left: 16.8%; width: 6%" target="_blank"	@click="openLink('https://instagram.com/Cartier')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[42] + ')'"></div>
						<div :style="'background-image:url(' + pages9[43] + ')'"></div>
						<div :style="'background-image:url(' + pages9[44] + ')'"></div>
						<div :style="'background-image:url(' + pages9[45] + ')'"></div>
						<div :style="'background-image:url(' + pages9[46] + ')'"></div>
						<div :style="'background-image:url(' + pages9[47] + ')'"></div>
						<div :style="'background-image:url(' + pages9[48] + ')'">							
							<a class="minilinks articles2" style="bottom: 4.5%; right: 39.6%; width: 9.2%" target="_blank"	@click="openLink('https://instagram.com/jeromefosterii')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[49] + ')'"></div>
						<div :style="'background-image:url(' + pages9[50] + ')'"></div>
						<div :style="'background-image:url(' + pages9[51] + ')'"></div>
						<div :style="'background-image:url(' + pages9[52] + ')'"></div>
						<div :style="'background-image:url(' + pages9[53] + ')'"></div>
						<div :style="'background-image:url(' + pages9[54] + ')'">
							<a class="links articles2" style="bottom: 4.5%; right: 38%; width: 10.8%" target="_blank"	@click="openLink('https://apottscollection.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[55] + ')'"></div>
						<div :style="'background-image:url(' + pages9[56] + ')'"></div>
						<div :style="'background-image:url(' + pages9[57] + ')'"></div>
						<div :style="'background-image:url(' + pages9[58] + ')'">
							<a class="minilinks articles2" style="bottom: 67.2%; right: 34.4%; width: 14.4%" target="_blank"	@click="openLink('https://instagram.com/a_claude_2020')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[59] + ')'">
							<a class="minilinks articles2" style="bottom: 24.5%; right: 10.2%; width: 7%" target="_blank"	@click="openLink('https://instagram.com/feminist')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[60] + ')'"></div>
						<div :style="'background-image:url(' + pages9[61] + ')'"></div>
						<div :style="'background-image:url(' + pages9[62] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 40%; width: 8.8%" target="_blank"	@click="openLink('https://instagram.com/domipalmer')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[63] + ')'"></div>
						<div :style="'background-image:url(' + pages9[64] + ')'"></div>
						<div :style="'background-image:url(' + pages9[65] + ')'"></div>
						<div :style="'background-image:url(' + pages9[66] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 36%; width: 13%" target="_blank"	@click="openLink('https://instagram.com/mcmillaray_oficial')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[67] + ')'"></div>
						<div :style="'background-image:url(' + pages9[68] + ')'"></div>
						<div :style="'background-image:url(' + pages9[69] + ')'">
							<a class="minilinks articles2" style="bottom: 4.3%; right: 38.6%; width: 10.8%" target="_blank"	@click="openLink('https://instagram.com/atillayoldas')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[70] + ')'"></div>
						<div :style="'background-image:url(' + pages9[71] + ')'"></div>
						<div :style="'background-image:url(' + pages9[72] + ')'"></div>
						<div :style="'background-image:url(' + pages9[73] + ')'"></div>
						<div :style="'background-image:url(' + pages9[74] + ')'"></div>
						<div :style="'background-image:url(' + pages9[75] + ')'"></div>
						<div :style="'background-image:url(' + pages9[76] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 40.5%; width: 8.4%" target="_blank"	@click="openLink('https://instagram.com/fredtjoseph')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[77] + ')'"></div>
						<div :style="'background-image:url(' + pages9[78] + ')'"></div>
						<div :style="'background-image:url(' + pages9[79] + ')'"></div>
						<div :style="'background-image:url(' + pages9[80] + ')'"></div>
						<div :style="'background-image:url(' + pages9[81] + ')'"></div>
						<div :style="'background-image:url(' + pages9[82] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 37.6%; width: 11.2%" target="_blank"	@click="openLink('https://instagram.com/hoda_khamoosh')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[83] + ')'"></div>
						<div :style="'background-image:url(' + pages9[84] + ')'"></div>
						<div :style="'background-image:url(' + pages9[85] + ')'"></div>
						<div :style="'background-image:url(' + pages9[86] + ')'">
							<a class="minilinks articles2" style="bottom: 61.2%; right: 39.8%; width: 9.4%" target="_blank"	@click="openLink('https://instagram.com/ayshka.n')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[87] + ')'"></div>
						<div :style="'background-image:url(' + pages9[88] + ')'"></div>
						<div :style="'background-image:url(' + pages9[89] + ')'"></div>
						<div :style="'background-image:url(' + pages9[90] + ')'"></div>
						<div :style="'background-image:url(' + pages9[91] + ')'"></div>
						<div :style="'background-image:url(' + pages9[92] + ')'"></div>
						<div :style="'background-image:url(' + pages9[93] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 38.6%; width: 10.4%" target="_blank"	@click="openLink('https://instagram.com/shirin__neshat')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[94] + ')'"></div>
						<div :style="'background-image:url(' + pages9[95] + ')'"></div>
						<div :style="'background-image:url(' + pages9[96] + ')'"></div>
						<div :style="'background-image:url(' + pages9[97] + ')'"></div>
						<div :style="'background-image:url(' + pages9[98] + ')'"></div>
						<div :style="'background-image:url(' + pages9[99] + ')'"></div>
						<div :style="'background-image:url(' + pages9[100] + ')'"></div>
						<div :style="'background-image:url(' + pages9[101] + ')'"></div>
						<div :style="'background-image:url(' + pages9[102] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 38.8%; width: 10.2%" target="_blank"	@click="openLink('https://instagram.com/kymyatehrani')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[103] + ')'"></div>
						<div :style="'background-image:url(' + pages9[104] + ')'"></div>
						<div :style="'background-image:url(' + pages9[105] + ')'"></div>
						<div :style="'background-image:url(' + pages9[106] + ')'"></div>
						<div :style="'background-image:url(' + pages9[107] + ')'"></div>
						<div :style="'background-image:url(' + pages9[108] + ')'">
							<a class="links articles2" style="bottom: 4.5%; right: 38.5%; width: 10%" target="_blank"	@click="openLink('https://instagram.com/masih.alinejad')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[109] + ')'"></div>
						<div :style="'background-image:url(' + pages9[110] + ')'"></div>
						<div :style="'background-image:url(' + pages9[111] + ')'"></div>
						<div :style="'background-image:url(' + pages9[112] + ')'"></div>
						<div :style="'background-image:url(' + pages9[113] + ')'"></div>
						<div :style="'background-image:url(' + pages9[114] + ')'">
							<a class="links articles2" style="bottom: 4.5%; right: 39%; width: 9.6%" target="_blank"	@click="openLink('https://instagram.com/nasablueberry')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[115] + ')'"></div>
						<div :style="'background-image:url(' + pages9[116] + ')'">
							<a class="links articles2" style="bottom: 57.3%; right: 30.8%; width: 18.2%" target="_blank"	@click="openLink('https://instagram.com/candyelle_wildheart')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[117] + ')'"></div>
						<div :style="'background-image:url(' + pages9[118] + ')'"></div>
						<div :style="'background-image:url(' + pages9[119] + ')'"></div>
						<div :style="'background-image:url(' + pages9[120] + ')'">
							<a class="minilinks articles2" style="bottom: 24.5%; left: 12.8%; width: 6.4%" target="_blank"	@click="openLink('https://tiktok.com/@tofology')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[121] + ')'"></div>
						<div :style="'background-image:url(' + pages9[122] + ')'">
							<a class="links articles2" style="bottom: 4.5%; right: 42.4%; width: 6.4%" target="_blank"	@click="openLink('https://twitter.com/abbieasr')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[123] + ')'"></div>
						<div :style="'background-image:url(' + pages9[124] + ')'">
							<a class="minilinks articles2" style="bottom: 81.1%; right: 33.6%; width: 15.4%" target="_blank"	@click="openLink('https://twitter.com/Children4peaceC')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[125] + ')'"></div>
						<div :style="'background-image:url(' + pages9[126] + ')'"></div>
						<div :style="'background-image:url(' + pages9[127] + ')'"></div>
						<div :style="'background-image:url(' + pages9[128] + ')'"></div>
						<div :style="'background-image:url(' + pages9[129] + ')'"></div>
						<div :style="'background-image:url(' + pages9[130] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 38.4%; width: 10.4%" target="_blank"	@click="openLink('https://blackgirlshack.org')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[131] + ')'">
							<a class="minilinks articles2" style="bottom: 4%; right: 41%; width: 8.4%" target="_blank"	@click="openLink('https://instagram.com/__ekow')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[132] + ')'"></div>
						<div :style="'background-image:url(' + pages9[133] + ')'"></div>
						<div :style="'background-image:url(' + pages9[134] + ')'"></div>
						<div :style="'background-image:url(' + pages9[135] + ')'"></div>
						<div :style="'background-image:url(' + pages9[136] + ')'">
							<a class="links articles2" style="bottom: 74.5%; right: 42%; width: 6.8%" target="_blank"	@click="openLink('https://twitter.com/jesswade')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[137] + ')'"></div>
						<div :style="'background-image:url(' + pages9[138] + ')'"></div>
						<div :style="'background-image:url(' + pages9[139] + ')'"></div>
						<div :style="'background-image:url(' + pages9[140] + ')'"></div>
						<div :style="'background-image:url(' + pages9[141] + ')'"></div>
						<div :style="'background-image:url(' + pages9[142] + ')'">
						<a class="minilinks articles2" style="bottom: 4.5%; right: 41.2%; width: 7.5%" target="_blank"	@click="openLink('https://www.facebook.com/people/Lamar-Ok/100008528592920/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[143] + ')'"></div>
						<div :style="'background-image:url(' + pages9[144] + ')'"></div>
						<div :style="'background-image:url(' + pages9[145] + ')'"></div>
						<div :style="'background-image:url(' + pages9[146] + ')'">
							<a class="minilinks articles2" style="bottom: 28.4%; right: 33.2%; width: 15.5%" target="_blank"	@click="openLink('https://instagram.com/helenadonatosapp')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[147] + ')'">
							<div class="video1">
								<vue-player ref="video1" id="video1"
									src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-9%2Fmedia%2Fpg146_Scultping_The_Mechanics.mp4?alt=media&token=00df33b3-ddee-4af7-adcd-19d5d986cb4a">
								</vue-player>
							</div>
							<a class="minilinks articles2"
								style="position: absolute; bottom: 20.5%; left: 82.5%; width: 14%; font-size: 1em; border-bottom: none !important"
								@click.prevent="playVideo1">ClickToPlay</a></div>
						<div :style="'background-image:url(' + pages9[148] + ')'"></div>
						<div :style="'background-image:url(' + pages9[149] + ')'"></div>
						<div :style="'background-image:url(' + pages9[150] + ')'">
							<a class="links articles2" style="bottom: 4.5%; right: 37.2%; width: 11.6%" target="_blank"	@click="openLink('https://instagram.com/daisy_collingridge')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[151] + ')'"></div>
						<div :style="'background-image:url(' + pages9[152] + ')'"></div>
						<div :style="'background-image:url(' + pages9[153] + ')'"></div>
						<div :style="'background-image:url(' + pages9[154] + ')'"></div>
						<div :style="'background-image:url(' + pages9[155] + ')'"></div>
						<div :style="'background-image:url(' + pages9[156] + ')'">
							<a class="minilinks articles2" style="bottom: 79.1%; right: 37.8%; width: 11%" target="_blank"	@click="openLink('https://instagram.com/imlakbachi')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[157] + ')'"></div>
						<div :style="'background-image:url(' + pages9[158] + ')'"></div>
						<div :style="'background-image:url(' + pages9[159] + ')'"></div>
						<div :style="'background-image:url(' + pages9[160] + ')'">
							<a class="minilinks articles2" style="bottom: 5.1%; right: 37.8%; width: 11.4%" target="_blank"	@click="openLink('https://youthforwomen.org')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[161] + ')'"></div>
						<div :style="'background-image:url(' + pages9[162] + ')'"></div>
						<div :style="'background-image:url(' + pages9[163] + ')'"></div>
						<div :style="'background-image:url(' + pages9[164] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 40%; width: 9%" target="_blank"	@click="openLink('https://instagram.com/ilonamaher')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[165] + ')'"></div>
						<div :style="'background-image:url(' + pages9[166] + ')'">
							<a class="minilinks articles2" style="bottom: 73.1%; right: 36.2%; width: 12.8%" target="_blank"	@click="openLink('https://instagram.com/ivine.wacho_')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[167] + ')'"></div>
						<div :style="'background-image:url(' + pages9[168] + ')'"></div>
						<div :style="'background-image:url(' + pages9[169] + ')'"></div>
						<div :style="'background-image:url(' + pages9[170] + ')'"></div>
						<div :style="'background-image:url(' + pages9[171] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 42%; width: 7.4%" target="_blank"	@click="openLink('https://instagram.com/c_sinc12')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[172] + ')'"></div>
						<div :style="'background-image:url(' + pages9[173] + ')'"></div>
						<div :style="'background-image:url(' + pages9[174] + ')'"></div>
						<div :style="'background-image:url(' + pages9[175] + ')'"></div>
						<div :style="'background-image:url(' + pages9[176] + ')'"></div>
						<div :style="'background-image:url(' + pages9[177] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 42%; width: 7.4%" target="_blank"	@click="openLink('https://instagram.com/bigfreedia')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[178] + ')'"></div>
						<div :style="'background-image:url(' + pages9[179] + ')'"></div>
						<div :style="'background-image:url(' + pages9[180] + ')'"></div>
						<div :style="'background-image:url(' + pages9[181] + ')'">
							<a class="links articles2" style="bottom: 5.2%; right: 20.4%; width: 9%" target="_blank"	@click="openLink('https://www.marcjacobs.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[182] + ')'"></div>
						<div :style="'background-image:url(' + pages9[183] + ')'"></div>
						<div :style="'background-image:url(' + pages9[184] + ')'">
							<a class="minilinks articles2" style="bottom: 13%; left: 19.8%; width: 12%" target="_blank"	@click="openLink('https://bottegaveneta.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5.1%; left: 19.8%; width: 15.8%" target="_blank"	@click="openLink('https://AlexanderMcQueen.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[185] + ')'"></div>
						<div :style="'background-image:url(' + pages9[186] + ')'">
							<a class="minilinks articles2" style="bottom: 11.4%; right: 2.8%; width: 5.6%" target="_blank"	@click="openLink('https://chanel.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 9.8%; right: 2.8%; width:5.5%" target="_blank"	@click="openLink('https://goldengoose.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 8.2%; right: 12.6%; width:4.2%" target="_blank"	@click="openLink('https://goldengoose.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 6.5%; right: 7%; width: 6.4%" target="_blank"	@click="openLink('https://stetson.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[187] + ')'">
							<a class="minilinks articles2" style="bottom: 5%; left: 4.8%; width: 5.5%" target="_blank"	@click="openLink('https://chanel.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[188] + ')'"></div>
						<div :style="'background-image:url(' + pages9[189] + ')'">
							<a class="minilinks articles2" style="bottom: 5%; left: 3%; width: 9%" target="_blank"	@click="openLink('https://www.marcjacobs.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[190] + ')'">
							<a class="links articles2" style="bottom: 5%; right: 3%; width: 10.5%" target="_blank"	@click="openLink('https://louisvuitton.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[191] + ')'"></div>
						<div :style="'background-image:url(' + pages9[192] + ')'">
							<a class="minilinks articles2" style="bottom: 88.9%; right: 3%; width: 9.4%" target="_blank"	@click="openLink('https://www.marcjacobs.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[193] + ')'">
							<a class="minilinks articles2" style="bottom: 5%; left: 3%; width: 11.4%" target="_blank"	@click="openLink('https://bottegaveneta.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[194] + ')'">
							<a class="minilinks articles2" style="bottom: 88.9%; right: 3%; width: 4%" target="_blank"	@click="openLink('https://www.gucci.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[195] + ')'">
							<a class="minilinks articles" style="bottom: 88.8%; left: 17.8%; width:5%" target="_blank"	@click="openLink('https://ralphlauren.com')">clik</a>
							<a class="minilinks articles" style="bottom: 87.2%; left: 3%; width: 6%" target="_blank"	@click="openLink('https://ralphlauren.com')">clik</a>
							<a class="minilinks articles" style="bottom: 87.2%; left: 19%; width: 3%" target="_blank"	@click="openLink('https://r13.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[196] + ')'"></div>
						<div :style="'background-image:url(' + pages9[197] + ')'"></div>
						<div :style="'background-image:url(' + pages9[198] + ')'"></div>
						<div :style="'background-image:url(' + pages9[199] + ')'"></div>
						<div :style="'background-image:url(' + pages9[200] + ')'">
							<a class="minilinks articles2" style="bottom: 6.1%; right: 42.8%; width: 5.4%" target="_blank"	@click="openLink('https://instagram.com/harinef')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[201] + ')'"></div>
						<div :style="'background-image:url(' + pages9[202] + ')'"></div>
						<div :style="'background-image:url(' + pages9[203] + ')'"></div>
						<div :style="'background-image:url(' + pages9[204] + ')'"></div>
						<div :style="'background-image:url(' + pages9[205] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 39%; width: 10.2%" target="_blank"	@click="openLink('https://whiskeychow.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[206] + ')'"></div>
						<div :style="'background-image:url(' + pages9[207] + ')'">
							<a class="minilinks articles2" style="bottom: 4.2%; right: 41.4%; width: 8.4%" target="_blank"	@click="openLink('https://instagram.com/j.thurbs')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[208] + ')'"></div>
						<div :style="'background-image:url(' + pages9[209] + ')'"></div>
						<div :style="'background-image:url(' + pages9[210] + ')'"></div>
						<div :style="'background-image:url(' + pages9[211] + ')'"></div>
						<div :style="'background-image:url(' + pages9[212] + ')'">
						<a class="minilinks articles2" style="bottom: 4.5%; right: 39.4%; width: 10%" target="_blank"	@click="openLink('https://instagram.com/oliviajulianna')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[213] + ')'"></div>
						<div :style="'background-image:url(' + pages9[214] + ')'"></div>
						<div :style="'background-image:url(' + pages9[215] + ')'"></div>
						<div :style="'background-image:url(' + pages9[216] + ')'"></div>
						<div :style="'background-image:url(' + pages9[217] + ')'">
						<a class="minilinks articles2" style="bottom: 4.5%;right: 35.8%; width: 13.4%" target="_blank"	@click="openLink('https://wolfevonlenkiewicz.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[218] + ')'"></div>
						<div :style="'background-image:url(' + pages9[219] + ')'"></div>
						<div :style="'background-image:url(' + pages9[220] + ')'"></div>
						<div :style="'background-image:url(' + pages9[221] + ')'"></div>
						<div :style="'background-image:url(' + pages9[222] + ')'"></div>
						<div :style="'background-image:url(' + pages9[223] + ')'"></div>
						<div :style="'background-image:url(' + pages9[224] + ')'"></div>
						<div :style="'background-image:url(' + pages9[225] + ')'"></div>
						<div :style="'background-image:url(' + pages9[226] + ')'">
						<a class="minilinks articles2" style="bottom: 61.2%; right: 33%; width: 16%" target="_blank"	@click="openLink('https://instagram.com/JulietaMartinezo')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[227] + ')'"></div>
						<div :style="'background-image:url(' + pages9[228] + ')'"></div>
						<div :style="'background-image:url(' + pages9[229] + ')'"></div>
						<div :style="'background-image:url(' + pages9[230] + ')'"></div>
						<div :style="'background-image:url(' + pages9[231] + ')'"></div>
						<div :style="'background-image:url(' + pages9[232] + ')'"></div>
						<div :style="'background-image:url(' + pages9[233] + ')'"></div>
						<div :style="'background-image:url(' + pages9[234] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 36.8%; width: 12.4%" target="_blank"	@click="openLink('https://instagram.com/esthermahlanguart')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[235] + ')'"></div>
						<div :style="'background-image:url(' + pages9[236] + ')'"></div>
						<div :style="'background-image:url(' + pages9[237] + ')'">
							<a class="minilinks articles2" style="bottom: 4.2%; right: 37.8%; width: 12%" target="_blank"	@click="openLink('https://instagram.com/coderbunnyz')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[238] + ')'"></div>
						<div :style="'background-image:url(' + pages9[239] + ')'"></div>
						<div :style="'background-image:url(' + pages9[240] + ')'"></div>
						<div :style="'background-image:url(' + pages9[241] + ')'"></div>
						<div :style="'background-image:url(' + pages9[242] + ')'"></div>
						<div :style="'background-image:url(' + pages9[243] + ')'"></div>
						<div :style="'background-image:url(' + pages9[244] + ')'"></div>
						<div :style="'background-image:url(' + pages9[245] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 41.8%; width: 7.4%" target="_blank"	@click="openLink('https://pixyliao.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[246] + ')'"></div>
						<div :style="'background-image:url(' + pages9[247] + ')'"></div>
						<div :style="'background-image:url(' + pages9[248] + ')'"></div>
						<div :style="'background-image:url(' + pages9[249] + ')'"></div>
						<div :style="'background-image:url(' + pages9[250] + ')'"></div>
						<div :style="'background-image:url(' + pages9[251] + ')'"></div>
						<div :style="'background-image:url(' + pages9[252] + ')'">
							<a class="minilinks articles2" style="bottom: 65.1%; right: 41%; width: 8%" target="_blank"	@click="openLink('https://instagram.com/sthjrdn')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[253] + ')'"></div>
						<div :style="'background-image:url(' + pages9[254] + ')'">
							<a class="links articles" style="bottom: 2.8%; left: 35%; width: 30%; font-size:12px" target="_blank"	@click="openBook">CLICK HERE TO DOWNLOAD</a>
						</div>
						<div :style="'background-image:url(' + pages9[255] + ')'"></div>
						<div :style="'background-image:url(' + pages9[256] + ')'"></div>
						<div :style="'background-image:url(' + pages9[257] + ')'"></div>
						<div :style="'background-image:url(' + pages9[258] + ')'"></div>
						<div :style="'background-image:url(' + pages9[259] + ')'"></div>
						<div :style="'background-image:url(' + pages9[260] + ')'">
							<a class="minilinks articles2" style="bottom: 4.5%; right: 37.8%; width: 10%" target="_blank"	@click="openLink('https://instagram.com/santojacobsson')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[261] + ')'"></div>
						<div :style="'background-image:url(' + pages9[262] + ')'"></div>
						<div :style="'background-image:url(' + pages9[263] + ')'"></div>
						<div :style="'background-image:url(' + pages9[264] + ')'"></div>
						<div :style="'background-image:url(' + pages9[265] + ')'">
							<a class="minilinks articles2" style="bottom: 4.4%; right: 35%; width: 14.2%" target="_blank"	@click="openLink('https://instagram.com/Matthew.Blaise')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[266] + ')'"></div>
						<div :style="'background-image:url(' + pages9[267] + ')'"></div>
						<div :style="'background-image:url(' + pages9[268] + ')'"></div>
						<div :style="'background-image:url(' + pages9[269] + ')'">
							<a class="minilinks articles2" style="bottom: 11.4%; left: 8%; width: 4.4%" target="_blank"	@click="openLink('https://prada.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; left: 9%; width: 6.5%" target="_blank"	@click="openLink('https://roksanda.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[270] + ')'"></div>
						<div :style="'background-image:url(' + pages9[271] + ')'">
							<a class="minilinks articles" style="bottom: 6.7%; left: 8%; width: 4.8%" target="_blank"	@click="openLink('https://www.gucci.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; left: 3%; width: 15.4%" target="_blank"	@click="openLink('https://alexandermcqueen.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[272] + ')'"></div>
						<div :style="'background-image:url(' + pages9[273] + ')'">
							<a class="minilinks articles2" style="bottom: 14.5%; left: 5%; width: 6%" target="_blank"	@click="openLink('https://balmain.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 6.7%; left: 3%; width: 8%" target="_blank"	@click="openLink('https://www.ferragamo.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; left: 9%; width: 11.4%" target="_blank"	@click="openLink('https://bottegaveneta.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[274] + ')'"></div>
						<div :style="'background-image:url(' + pages9[275] + ')'"></div>
						<div :style="'background-image:url(' + pages9[276] + ')'"></div>
						<div :style="'background-image:url(' + pages9[277] + ')'">
							<a class="minilinks articles2" style="bottom: 6.7%; left: 3%; width: 7%" target="_blank"	@click="openLink('https://www.givenchy.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5.1%; left: 5%; width: 4.5%" target="_blank"	@click="openLink('https://coach.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[278] + ')'"></div>
						<div :style="'background-image:url(' + pages9[279] + ')'">
							<a class="minilinks articles2" style="bottom: 8.2%; left: 14.8%; width: 4%" target="_blank"	@click="openLink('https://dior.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 6.6%; left: 14.4%; width: 6%" target="_blank"	@click="openLink('https://www.dunhill.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[280] + ')'"></div>
						<div :style="'background-image:url(' + pages9[281] + ')'"></div>
						<div :style="'background-image:url(' + pages9[282] + ')'">
							<a class="minilinks articles2" style="bottom: 13%; right: 7%; width: 6.4%" target="_blank" @click="openLink('https://mugler.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 11.4%; right: 3%; width: 4.5%" target="_blank" @click="openLink('https://prada.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; right: 3%; width: 11%" target="_blank" @click="openLink('https://entirestudios.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[283] + ')'">
							<a class="minilinks articles2" style="bottom: 89%; left: 8.5%; width: 7.4%" target="_blank" @click="openLink('https://gauchere.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 87.1%; left: 7%; width: 7.8%" target="_blank" @click="openLink('https://moschino.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 85.5%; left: 14%; width: 4%" target="_blank" @click="openLink('https://prada.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[284] + ')'"></div>
						<div :style="'background-image:url(' + pages9[285] + ')'">
							<a class="minilinks articles2" style="bottom: 9.8%; left: 8.8%; width: 6%" target="_blank" @click="openLink('https://www.versace.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5.1%; left: 5%; width: 5.8%" target="_blank" @click="openLink('https://mugler.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[286] + ')'"></div>
						<div :style="'background-image:url(' + pages9[287] + ')'"></div>
						<div :style="'background-image:url(' + pages9[288] + ')'"></div>
						<div :style="'background-image:url(' + pages9[289] + ')'"></div>
						<div :style="'background-image:url(' + pages9[290] + ')'">
							<a class="minilinks articles2" style="bottom: 11.4%; right: 3%; width: 11%" target="_blank" @click="openLink('https://entirestudios.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; right: 3%; width: 6%" target="_blank" @click="openLink('https://chanel.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[291] + ')'">
							<a class="minilinks articles2" style="bottom: 12.9%; left: 10.8%; width: 11%" target="_blank" @click="openLink('https://entirestudios.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 8.2%; left: 13%; width: 6%" target="_blank" @click="openLink('https://chanel.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; left:5%; width: 6%" target="_blank" @click="openLink('https://www.dunhill.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[292] + ')'"></div>
						<div :style="'background-image:url(' + pages9[293] + ')'">
							<a class="minilinks articles2" style="bottom: 87.2%; left: 7%; width: 4.4%" target="_blank" @click="openLink('https://coach.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 79.4%; left: 16.5%; width: 4%" target="_blank" @click="openLink('https://www.marcjacobs.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 77.8%; left: 3%; width: 5%" target="_blank" @click="openLink('https://www.marcjacobs.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 77.8%; left: 15.5%; width: 4.4%" target="_blank" @click="openLink('https://coach.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[294] + ')'"></div>
						<div :style="'background-image:url(' + pages9[295] + ')'">
							<a class="minilinks articles2" style="bottom: 12.9%; left: 8%; width: 11%" target="_blank" @click="openLink('https://us.louisvuitton.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 8.2%; left: 8.5%; width: 12.2%" target="_blank" @click="openLink('https://mollygoddard.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 5%; left: 3%; width: 10.4%" target="_blank" @click="openLink('https://simonerocha.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[296] + ')'"></div>
						<div :style="'background-image:url(' + pages9[297] + ')'">
							<a class="minilinks articles2" style="bottom: 5%; left: 3%; width: 9%" target="_blank" @click="openLink('https://www.marcjacobs.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[298] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 12%; bottom: 85.8%;" target="_blank" @click="openLink('http://productionising.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[299] + ')'"></div>
						<div :style="'background-image:url(' + pages9[300] + ')'">
							<a class="minilinks articles2" style="right: 35%; width: 14%; bottom: 75.1%;" target="_blank" @click="openLink('https://instagram.com/selinozunaldim')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[301] + ')'"></div>
						<div :style="'background-image:url(' + pages9[302] + ')'"></div>
						<div :style="'background-image:url(' + pages9[303] + ')'"></div>
						<div :style="'background-image:url(' + pages9[304] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 5%; bottom: 5%;" target="_blank" @click="openLink('https://prada.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[305] + ')'">
							<a class="minilinks articles2" style="left: 3%; width: 8%; bottom: 6.6%;" target="_blank" @click="openLink('https://valentino.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[306] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 4%; bottom:5%;" target="_blank" @click="openLink('https://dior.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[307] + ')'"></div>
						<div :style="'background-image:url(' + pages9[308] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 8%; bottom:5%;" target="_blank" @click="openLink('https://www.ferragamo.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[309] + ')'">
							<a class="minilinks articles2" style="left: 7%; width: 4.5%; bottom: 4.8%;" target="_blank" @click="openLink('https://www.gucci.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[310] + ')'">
							<a class="minilinks articles2" style="right: 16%; width: 6%; bottom:6.7%;" target="_blank" @click="openLink('https://www.versace.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[311] + ')'">
							<a class="minilinks articles2" style="bottom: 5%; left: 11%; width: 10%;" target="_blank" @click="openLink('https://louisvuitton.com')">clik</a>							
						</div>
						<div :style="'background-image:url(' + pages9[312] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 12%; bottom:88.4%;" target="_blank" @click="openLink('https://www.armani.com/en-u')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[313] + ')'">
							<a class="minilinks articles2" style="left: 12%; width: 7%; bottom:5%;" target="_blank" @click="openLink('https://www.givenchy.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[314] + ')'"></div>
						<div :style="'background-image:url(' + pages9[315] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 11.5%; bottom:87.2%;" target="_blank" @click="openLink('https://celine.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[316] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 6%; bottom:87.3%;" target="_blank" @click="openLink('https://chanel.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[317] + ')'">
							<a class="minilinks articles2" style="bottom: 5%; left: 11%; width: 10%;" target="_blank" @click="openLink('https://alexandermcqueen.com')">clik</a>							
						</div>
						<div :style="'background-image:url(' + pages9[318] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 21%; bottom:5%;" target="_blank" @click="openLink('https://ysl.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[319] + ')'"></div>
						<div :style="'background-image:url(' + pages9[320] + ')'">
							<a class="minilinks articles2" style="bottom: 43.3%; right: 3%; width: 4%;" target="_blank" @click="openLink('https://ralphlauren.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 41.7%; right: 16%; width: 5.4%;" target="_blank" @click="openLink('https://ralphlauren.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[321] + ')'">
							<a class="minilinks articles2" style="bottom: 88.7%; left: 12%; width: 6.5%;" target="_blank" @click="openLink('https://burberry.com')">clik</a>							
						</div>
						<div :style="'background-image:url(' + pages9[322] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 5%; bottom: 88.8%;" target="_blank" @click="openLink('https://loewe.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[323] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 7.6%; bottom: 44.4%;" target="_blank" @click="openLink('https://instagram.com/alexconsani')">clik</a>
							<a class="minilinks articles2" style="right: 43%; width: 6%; bottom: 47.8%;" target="_blank" @click="openLink('https://instagram.com/azemezi')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[324] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 9.5%; bottom: 51.2%;" target="_blank" @click="openLink('https://instagram.com/capri____son')">clik</a>
							<a class="minilinks articles2" style="right: 39.8%; width: 9%; bottom: 42.6%;" target="_blank" @click="openLink('https://instagram.com/connorwr0ng')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[325] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 9%; bottom: 44.4%;" target="_blank" @click="openLink('https://instagram.com/emily__driver')">clik</a>
							<a class="minilinks articles2" style="right: 41.4%; width: 8%; bottom: 49.6%;" target="_blank" @click="openLink('https://instagram.com/jakejunkins')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[326] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 8.5%; bottom: 44.4%;" target="_blank" @click="openLink('https://instagram.com/theronnegri')">clik</a>
							<a class="minilinks articles2" style="right: 39.5%; width: 9.2%; bottom: 42.6%;" target="_blank" @click="openLink('https://instagram.com/hannegabysees')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[327] + ')'"></div>
						<div :style="'background-image:url(' + pages9[328] + ')'"></div>
						<div :style="'background-image:url(' + pages9[329] + ')'"></div>
						<div :style="'background-image:url(' + pages9[330] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 16%; bottom: 6.7%;" target="_blank" @click="openLink('https://alexandermcqueen.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[331] + ')'"></div>
						<div :style="'background-image:url(' + pages9[332] + ')'"></div>
						<div :style="'background-image:url(' + pages9[333] + ')'">
							<a class="minilinks articles2" style="left: 5%; width: 6%; bottom: 5%;" target="_blank" @click="openLink('https://www.dunhill.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[334] + ')'"></div>
						<div :style="'background-image:url(' + pages9[335] + ')'"></div>
						<div :style="'background-image:url(' + pages9[336] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 13%; bottom: 5%;" target="_blank" @click="openLink('https://dolcegabbana.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[337] + ')'">
							<a class="minilinks articles2" style="left: 9%; width: 9.4%; bottom: 9.8%;" target="_blank" @click="openLink('https://www.instagram.com/warpigwonder')">clik</a>
							<a class="minilinks articles2" style="left: 3%; width: 10%; bottom: 6.6%;" target="_blank" @click="openLink('https://www.instagram.com/xuesong__yang')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[338] + ')'"></div>
						<div :style="'background-image:url(' + pages9[339] + ')'"></div>
						<div :style="'background-image:url(' + pages9[340] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 16%; bottom: 7.2%;" target="_blank" @click="openLink('https://ralphlauren.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[341] + ')'"></div>
						<div :style="'background-image:url(' + pages9[342] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 17.5%; bottom: 6%;" target="_blank" @click="openLink('https://ysl.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[343] + ')'"></div>
						<div :style="'background-image:url(' + pages9[344] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 8%; bottom: 5%;" target="_blank" @click="openLink('https://dior.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[345] + ')'">
							<a class="minilinks articles2" style="left: 5%; width: 15%; bottom: 9.8%;" target="_blank" @click="openLink('https://louisvuitton.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[346] + ')'"></div>
						<div :style="'background-image:url(' + pages9[347] + ')'"></div>
						<div :style="'background-image:url(' + pages9[348] + ')'">
							<a class="minilinks articles2" style="right: 3%; width: 5%; bottom: 12.9%;" target="_blank" @click="openLink('https://simonerocha.com')">clik</a>
							<a class="minilinks articles2" style="right: 12.5%; width: 5%; bottom: 11.4%;" target="_blank" @click="openLink('https://simonerocha.com')">clik</a>
							<a class="minilinks articles2" style="right: 3%; width: 5%; bottom: 9.8%;" target="_blank" @click="openLink('https://www.numeroventuno.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[349] + ')'"></div>
						<div :style="'background-image:url(' + pages9[350] + ')'">
							<a class="minilinks articles2" @click="onPlayerReadyTbss(media[144])"
								style="bottom: 6.2%; right: 2%; width: 13%; font-size: 1rem; text-decoration: none"> ClicktoPlay </a>
						</div>
						<div :style="'background-image:url(' + pages9[351] + ')'"></div>
						<div :style="'background-image:url(' + pages9[352] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 10.8%; bottom: 35.6%;" target="_blank" @click="openLink('https://instagram.com/_matthewkeller')">clik</a>
							<a class="minilinks articles2" style="left: 50.8%; width: 10%; bottom: 60%;" target="_blank" @click="openLink('https://instagram.com/corbincaptures')">clik</a>
							<a class="minilinks articles2" style="left: 50.8%; width: 13.5%; bottom: 5.9%;" target="_blank" @click="openLink('https://instagram.com/brandon_brereton_')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[353] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 8%; bottom: 35.6%;" target="_blank" @click="openLink('https://www.instagram.com/eth4nwood_')">clik</a>
							<a class="minilinks articles2" style="left: 50.8%; width: 5%; bottom: 60%;" target="_blank" @click="openLink('https://instagram.com/nrg_p')">clik</a>
							<a class="minilinks articles2" style="left: 50.8%; width: 7%; bottom: 5.8%;" target="_blank" @click="openLink('https://instagram.com/w8inaina')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[354] + ')'">
							<a class="minilinks articles2" style="left: 6%; width: 9%; bottom: 30.2%;" target="_blank" @click="openLink('https://instagram.com/thatasadguy')">clik</a>
							<a class="minilinks articles2" style="left: 23.5%; width: 5%; bottom: 30.2%;" target="_blank" @click="openLink('https://twitter.com/as1z_')">clik</a>
							<a class="minilinks articles2" style="left: 51%; width: 9.5%; bottom: 51.2%;" target="_blank" @click="openLink('https://instagram.com/rizal_ramaa')">clik</a>
							<a class="minilinks articles2" style="left: 70%; width: 8%; bottom: 51.2%;" target="_blank" @click="openLink('https://www.tiktok.com/@rizalramaa')">clik</a>
							<a class="minilinks articles2" style="left: 51%; width: 7%; bottom: 5.8%;" target="_blank" @click="openLink('https://instagram.com/ceilimusic')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages9[355] + ')'"></div>
						<div :style="'background-image:url(' + pages9[356] + ')'"></div>
						<div :style="'background-image:url(' + pages9[357] + ')'"></div>
						<div :style="'background-image:url(' + pages9[358] + ')'">
							<a class="minilinks articles2" style="right: 36.9%; width: 12%; bottom: 75.1%;" target="_blank" @click="openLink('https://instagram.com/manyanye04')">clik</a>
						</div>						
						<div :style="'background-image:url(' + pages9[359] + ')'">
							<!-- Stockits left A-->
							<a class="minilinks articles2" style="bottom:72.3%;  left: 26%; width: 17%" target="_blank" @click="openLink('https://alexandermcqueen.com')">clik</a>
							<a class="minilinks articles2" style="bottom:67.3%;  left: 26%; width: 15%" target="_blank" @click="openLink('https://anothertomorrow.co')">clik</a>
							<a class="minilinks articles2" style="bottom:62.3%;  left: 26%; width: 9%;" target="_blank" @click="openLink('https://balmain.com')">clik</a>					
							<a class="minilinks articles2" style="bottom:57.4%; left: 26%; width: 15%" target="_blank" @click="openLink('https://bitetoothpastebits.com')">clik</a>
							<a class="minilinks articles2" style="bottom:52.5%;  left: 26%; width: 13.4%" target="_blank" @click="openLink('https://bottegaveneta.com')">clik</a>
							<a class="minilinks articles2" style="bottom:47.6%;  left: 26%; width: 9.4%" target="_blank" @click="openLink('https://burberry.com')">clik</a>
							<a class="minilinks articles2" style="bottom:42.6%;  left: 26%; width: 7%" target="_blank" @click="openLink('https://celine.com')">clik</a>
							<a class="minilinks articles2" style="bottom:37.7%;  left: 26%; width: 12.5%" target="_blank" @click="openLink('https://wearechance.com')">clik</a>
							<a class="minilinks articles2" style="bottom:32.8%;  left: 26%; width: 8%" target="_blank" @click="openLink('https://chanel.com')">clik</a>
							<a class="minilinks articles2" style="bottom:27.8%; left: 26%; width: 6%" target="_blank" @click="openLink('https://clhu.com')">clik</a>
							<a class="minilinks articles2" style="bottom:22.8%; left: 26%; width: 7.5%" target="_blank" @click="openLink('https://coach.com')">clik</a>
							<a class="minilinks articles2" style="bottom:  18%; left: 26%; width: 13%" target="_blank" @click="openLink('https://collinastrada.com')">clik</a>
							<a class="minilinks articles2" style="bottom:  13%; left: 26%; width: 13.8%" target="_blank" @click="openLink('https://livecostabrazil.com')">clik</a>

								<!-- stockits right  A-->
              				<a class="minilinks articles2" style="bottom:72.3%;  left: 61.4%; width: 10.4%" target="_blank" @click="openLink('https://dick-moby.com')">clik</a>
							<a class="minilinks articles2" style="bottom:67.3%; left: 61.4%; width: 6%" target="_blank" @click="openLink('https://dior.com')">clik</a>
							<a class="minilinks articles2" style="bottom:62.3%;  left: 61.4%; width: 11.5%" target="_blank" @click="openLink('https://dolcegabbana.com')">clik</a>
							<a class="minilinks articles2" style="bottom:57.4%;  left: 61.4%; width: 8%" target="_blank" @click="openLink('https://www.dunhill.com')">clik</a>					
							<a class="minilinks articles2" style="bottom:52.5%; left: 61.4%; width: 14%" target="_blank" @click="openLink('https://warpigwonder.com')">clik</a>
							<a class="minilinks articles2" style="bottom:47.6%;  left: 61.4%; width: 12.2%" target="_blank" @click="openLink('https://www.armani.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom:42.6%;  left: 61.4%; width: 12%" target="_blank" @click="openLink('https://entirestudios.com')">clik</a>
							<a class="minilinks articles2" style="bottom:37.7%;  left: 61.4%; width: 14%" target="_blank" @click="openLink('https://everybody.world')">clik</a>
							<a class="minilinks articles2" style="bottom:32.8%;  left: 61.4%; width: 11%" target="_blank" @click="openLink('https://fmillerskincare.com')">clik</a>
							<a class="minilinks articles2" style="bottom:27.8%; left: 61.4%; width: 9.4%" target="_blank" @click="openLink('https://www.ferragamo.com')">clik</a>
							<a class="minilinks articles2" style="bottom:22.8%; left: 61.4%; width: 9.4%" target="_blank" @click="openLink('https://gauchere.com')">clik</a>
							<a class="minilinks articles2" style="bottom:  18%; left: 61.4%; width: 11.4%" target="_blank" @click="openLink('https://www.givenchy.com')">clik</a>
							<a class="minilinks articles2" style="bottom:  13%; left: 61.4%; width: 7%" target="_blank" @click="openLink('https://goldengoose.com')">clik</a>				
            			</div>
						<div :style="'background-image:url(' + pages9[360] + ')'">             
							<!-- Stockits left B-->
							<a class="minilinks articles2" style="bottom:72.3%;   left: 5%; width: 11%;" target="_blank"
								@click="openLink('https://isseymiyake.com')">clik</a>
							<a class="minilinks articles2" style="bottom:67.3%;   left: 5%; width:6%;" target="_blank"
								@click="openLink('https://jins.com')">clik</a>
							<a class="minilinks articles2" style="bottom:62.3%;   left: 5%; width: 13.5%;" target="_blank"
								@click="openLink('https://lauralombardi.com')">clik</a>
							<a class="minilinks articles2" style="bottom:57.4%;   left: 5%; width: 7.2%;" target="_blank"
								@click="openLink('https://loewe.com')">clik</a>
							<a class="minilinks articles2" style="bottom:52.5%;   left: 5%; width: 12%;" target="_blank"
								@click="openLink('https://louisvuitton.com')">clik</a>
							<a class="minilinks articles2" style="bottom:47.6%;   left: 5%; width: 11.5%;" target="_blank"
								@click="openLink('https://www.marcjacobs.com')">clik</a>
							<a class="minilinks articles2" style="bottom:42.6%;   left: 5%; width: 13.5%" target="_blank"
								@click="openLink('https://mollygoddard.com')">clik</a>
							<a class="minilinks articles2" style="bottom:37.7%;  left: 5%; width: 9%" target="_blank"
								@click="openLink('https://moschino.com')">clik</a>
							<a class="minilinks articles2" style="bottom:32.8%;   left: 5%; width: 8.5%" target="_blank"
								@click="openLink('https://mugler.com')">clik</a>
							<a class="minilinks articles2" style="bottom:27.8%; left: 5%; width: 13.5%" target="_blank"
								@click="openLink('https://numeroventuno.com')">clik</a>
							<a class="minilinks articles2" style="bottom:22.8%;  left: 5%; width: 15.5%" target="_blank"
								@click="openLink('https://orangeculture.com.ng')">clik</a>
							<a class="minilinks articles2" style="bottom:  18%;  left: 5%; width: 15.5%" target="_blank"
								@click="openLink('https://palladiumboots.co.uk')">clik</a>
							<a class="minilinks articles2" style="bottom:  13%;  left: 5%; width: 8%" target="_blank"
								@click="openLink('https://prada.com')">clik</a>
							
              				<!-- stockits right B-->		
							<a class="minilinks articles2" style="bottom:72.3%; left: 41.5%; width: 6%" target="_blank"
								@click="openLink('https://r13.com')">clik</a>
							<a class="minilinks articles2" style="bottom:67.3%; left: 41.5%; width: 13%" target="_blank"
								@click="openLink('https://ralphlauren.com')">clik</a>
							<a class="minilinks articles2" style="bottom:62.3%; left: 41.5%; width: 10%" target="_blank"
								@click="openLink('https://roksanda.com')">clik</a>
							<a class="minilinks articles2" style="bottom:57.4%;  left: 41.5%; width: 5%;" target="_blank"
								@click="openLink('https://ysl.com')">clik</a>												
							<a class="minilinks articles2" style="bottom:52.5%; left: 41.5%; width: 10.8%" target="_blank"
								@click="openLink('https://saltandstone.com')">clik</a>
							<a class="minilinks articles2" style="bottom:47.6%;  left: 41.5%; width: 10.8%" target="_blank"
								@click="openLink('https://simonerocha.com')">clik</a>
							<a class="minilinks articles2" style="bottom:42.6%;  left: 41.5%; width: 8%" target="_blank"
								@click="openLink('https://stetson.com')">clik</a>
							<a class="minilinks articles2" style="bottom:37.7%;  left: 41.5%; width: 14.5%" target="_blank"
								@click="openLink('https://studionicholson.com')">clik</a>
							<a class="minilinks articles2" style="bottom:32.8%;left: 41.5%; width: 10.2%" target="_blank"
								@click="openLink('https://valentino.com')">clik</a>
							<a class="minilinks articles2" style="bottom:27.8%;left: 41.5%; width: 8%" target="_blank"
								@click="openLink('https://www.versace.com')">clik</a>
							<a class="minilinks articles2" style="bottom:27.8%;left: 41.5%; width: 8%" target="_blank"
								@click="openLink('https://www.versace.com')">clik</a>
							</div>
							<div :style="'background-image:url(' + pages9[361] + ')'"></div>
							<div :style="'background-image:url(' + pages9[362] + ')'"></div>
							<div :style="'background-image:url(' + pages9[363] + ')'">
								<a class="minilinks articles2" style="bottom:10.5%;left: 38.5%; width: 23%" target="_blank"
									@click="openLink('mailto:info@missionmag.org')">clik</a>
						</div>						
						<div :style="'background-image:url(' + pages9[364] + ')'"></div>
						<div :style="'background-image:url(' + pages9[365] + ')'"></div>						
					</div>
					<div class="flipbook-video video-content" id="video-Tbss" v-show="verTbss">
						<b-embed type="video" :src="infoModalTbss.src" id="videoTbss" autoplay allow="autoplay" :controls="false"
							allowfullscreen></b-embed>
					</div>					
				</div>
				<index v-if="index"></index>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import "@/lib/turn.js";
import "@/lib/zoom.js";
import "@/lib/hash.js";
import index from "./Index";
import loader from "../../containers/loader";
import vuePlayer from "@algoz098/vue-player";

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    index,
    loader,
    vuePlayer
  },
  data() {
    return {
      infoModalTbss: {
        src: "",
        isPlay: false,
      },
      verTbss: false,
      
    };
  },

  created() {
     this.loadMagazine9();
  },
  mounted() {
    function loadApp() {
      $("#canvas").fadeIn(4000);

      var o = $(".flipbook");
      0 != o.width() && 0 != o.height()
        ? (o.turn({
          width: 1650,
          height: 990,
          duration: 4000,
          acceleration: !isChrome(),
          gradients: !0,
          autoCenter: !0,
          elevation: 200,
          when: {
            turning: function (o, i, n) {
              	var e = $(this),
              	a = e.turn("page");
				e.turn("pages");
				var btnClick = document.getElementById('btnClick');
				/*Cuando se haga clic*/
				btnClick.onmousedown = function() {
					const media1 = document.getElementById("videoTbss");
					media1.pause();
					$("#video-Tbss").hide();
				};               

            disableControls(i),
                $(".thumbnails .page-" + a)
                  .parent()
                  .removeClass("current"),
                $(".thumbnails .page-" + i)
                  .parent()
                  .addClass("current");
            },
            turned: function (o, i, n) {
              disableControls(i), $(this).turn("center"), 1 == i && $(this).turn("peel", "br");
            },
            missing: function (o, i) {
              for (var n = 0; n < i.length; n++) addPage(i[n], $(this));
            },
          },
        }),
          $(".flipbook-viewport").zoom({
            flipbook: $(".flipbook"),
            max: function () {
              return largeMagazineWidth() / $(".flipbook").width();
            },
            when: {
              swipeLeft: function () {
                $(this).zoom("flipbook").turn("next");
              },
              swipeRight: function () {
                $(this).zoom("flipbook").turn("previous");
              },
              resize: function (o, i, n, e) {
                1 == i ? loadSmallPage(n, e) : loadLargePage(n, e);
              },
              zoomIn: function () {
                $(".thumbnails").hide(),
                  $(".made").hide(),
                  $(".flipbook").removeClass("animated").addClass("zoom-in"),
                  $(".zoom-icon").removeClass("zoom-icon-in").addClass("zoom-icon-out"),
                  window.escTip || $.isTouch || (escTip = !0);
              },
              zoomOut: function () {
                $(".exit-message").hide(),
                  $(".made").fadeIn(),
                  $(".zoom-icon").removeClass("zoom-icon-out").addClass("zoom-icon-in"),
                  setTimeout(function () {
                    $(".flipbook").addClass("animated").removeClass("zoom-in"), resizeViewport();
                  }, 0);
              },
            },
          }),
          // pasar hojas con flechas

          $(document).keydown(function (e) {
            var options = $(".flipbook").turn("options");

            var previous = 37,
              next = 39,
              esc = 27;

            switch (e.keyCode) {
              case previous:
                // left arrow
                $(".flipbook").turn("previous");
                e.preventDefault();
                break;

              case next:
                //right arrow
                $(".flipbook").turn("next");
                e.preventDefault();
                break;

              case esc:
                $(".flipbook").turn("size", options.width, options.height);
                e.preventDefault();

                break;
            }
          }),
          $(window)
            .resize(function () {
              resizeViewport();
            })
            .bind("orientationchange", function () {
              resizeViewport();
            }),
          // $.isTouch ? $(".flipbook").bind("touchstart", regionClick) : $(".flipbook").click(regionClick),
          resizeViewport(),
          $(".flipbook").addClass("animated"))
        : setTimeout(loadApp, 10);
    }

    $(".zoom-icon")
      .bind("mouseover", function () {
        $(this).hasClass("zoom-icon-in") && $(this).addClass("zoom-icon-in-hover"),
          $(this).hasClass("zoom-icon-out") && $(this).addClass("zoom-icon-out-hover");
      })
      .on("mouseout", function () {
        $(this).hasClass("zoom-icon-in") && $(this).removeClass("zoom-icon-in-hover"),
          $(this).hasClass("zoom-icon-out") && $(this).removeClass("zoom-icon-out-hover");
      })
      .on("click", function () {
        toggleFullscreen();
      }),
      $("#canvas").hide();

    //FUNCTIONS TURNJS
    function resizeViewport() {
      var width = $(window).width(),
        height = $(window).height(),
        options = $(".flipbook").turn("options");

      $(".flipbook").removeClass("animated");

      $(".flipbook-viewport")
        .css({
          width: width,
          height: height,
        })
        .zoom("resize");

      if ($(".flipbook").turn("zoom") == 1) {
        var bound = calculateBound({
          width: options.width,
          height: options.height,
          boundWidth: Math.min(options.width, width),
          boundHeight: Math.min(options.height, height),
        });

        if (bound.width % 2 !== 0) bound.width -= 1;

        if (bound.width != $(".flipbook").width() || bound.height != $(".flipbook").height()) {
          $(".flipbook").turn("size", bound.width, bound.height);

          if ($(".flipbook").turn("page") == 1) $(".flipbook").turn("peel", "br");

          $(".next-button").css({
            height: bound.height,
            backgroundPosition: "-38px " + (bound.height / 2 - 32 / 2) + "px",
          });
          $(".previous-button").css({
            height: bound.height,
            backgroundPosition: "-4px " + (bound.height / 2 - 32 / 2) + "px",
          });
        }

        $(".flipbook").css({
          top: -bound.height / 2,
          left: -bound.width / 2,
        });

        $(".flipbook-video").css({
          width: bound.width + 10,
          height: bound.height,
          top: -bound.height / 2,
          left: -bound.width / 2,
          padding: 0,
        });
      }

      var magazineOffset = $(".flipbook").offset(),
        boundH = height - magazineOffset.top - $(".flipbook").height(),
        marginTop = (boundH - $(".thumbnails > div").height()) / 2;

      if (marginTop < 0) {
        $(".thumbnails").css({
          height: 1,
        });
      } else {
        $(".thumbnails").css({
          height: boundH,
        });
        $(".thumbnails > div").css({
          marginTop: marginTop,
        });
      }

      if (magazineOffset.top < $(".made").height()) $(".made").hide();
      else $(".made").show();

      $(".flipbook").addClass("animated");
    }

    function isChrome() {
      return navigator.userAgent.indexOf("Chrome") != -1;
    }

    function calculateBound(d) {
      var bound = {
        width: d.width,
        height: d.height,
      };

      if (bound.width > d.boundWidth || bound.height > d.boundHeight) {
        var rel = bound.width / bound.height;

        if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {
          bound.width = Math.round(d.boundHeight * rel);
          bound.height = d.boundHeight;
        } else {
          bound.width = d.boundWidth;
          bound.height = Math.round(d.boundWidth / rel);
        }
      }

      return bound;
    }

    function toggleFullscreen(elem) {
      var options = $(".flipbook").turn("options");

      elem = elem || document.documentElement;
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          $(".flipbook").turn("zoom", 1.5);
          $(".flipbook").turn("center");
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          $(".flipbook").turn("zoom", 1.5);
          $(".flipbook").turn("center");
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
          $(".flipbook").turn("zoom", 1.5);
          $(".flipbook").turn("center");
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          $(".flipbook").turn("zoom", 1.5);
          $(".flipbook").turn("center");
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        }
      }
    }

    function disableControls(page) {
      if (page == 1) $(".previous-button").hide();
      else $(".previous-button").show();

      if (page == $(".flipbook").turn("pages")) $(".next-button").hide();
      else $(".next-button").show();
    }

    function loadSmallPage(page, pageElement) {
      var img = pageElement.find("img");

      img.css({
        width: "100%",
        height: "100%",
      });

      img.unbind("load");
    }
    // large page
    function loadLargePage(page, pageElement) {
      var img = $("<div />");

      img.load(function () {
        var prevImg = pageElement.find("img");

        $(this).css({
          width: "100%",
          height: "100%",
        });
        $(this).appendTo(pageElement);
        prevImg.remove();
      });
    }
    loadApp();
  },
  methods: {  
    //modal embed

    cambiarEstado(newEstado) {
      this.estado = newEstado;
      if (newEstado == "/index") {
        this.setClass(true);
        this.pause();
        this.ver = false;
      } else {
        this.$router.push(this.estado);
        this.setClass(false);
        this.pause();
        this.ver = false;
      }
    },
    onPlayerReadyTbss(reproducir) {
      this.infoModalTbss.isPlay = true;
      this.infoModalTbss.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoTbss");
        media.load();
        media.play();
        this.infoModalTbss.isPlay = true;
        this.verTbss = true;
      }, 100);
    },
    openLink(url) {
      window.open(url);
    },
    openBook() {
      let route = this.$router.resolve("/colorbook/9");
      window.open(route.href, "_blank");
    },
    pause() {
      if (this.infoModalTbss.isPlay == true) {
        const media = document.getElementById("videoTbss");
        media.pause();
        this.verTbss = false;
        this.infoModalTbss.isPlay = false;
      }     
      if (this.$refs.video1.playing == true) {
        this.$refs.video1.playing == false;
        this.$refs.video1.$refs.video.pause();
      }   
    },
    playVideo1() {
      this.$refs.video1.$refs.video.load();
      this.$refs.video1.$refs.video.play();
    },
    pageNext() {
      $(".flipbook").turn("next");
      this.pause();
    },
    pagePrev() {
      $(".flipbook").turn("previous");
      this.pause();
    },

    ...mapActions("magazine", ["loadMagazine9"]),
    ...mapMutations("magazine", ["setClass"]),
	},
	computed: {  
		...mapState("magazine", ["index", "pages9", "loading", "media"]),
	},
};
</script>

<style lang="scss">
video {
	object-fit: cover !important;
}

.video1 {
	position: absolute;
	top: 32.5%;
	left: 5.1%;
	width: 90%;
	z-index: 12;
}

#video1 {
	.vue-video-player-controls {
		max-height: 5px !important;
		display: none;
		left: 7% !important;
		right: 7% !important;
		padding: 5px;
		position: absolute;
		bottom: 5% !important;
		background-color: rgba(0, 0, 0, 0) !important;
	}

	.start-button {
		width: auto;
		height: auto;
		border: none;
		border-radius: none;
		background-color: rgba(0, 0, 0, 0);
		cursor: none;
	}

	.button {
		width: 35px;
		border: none !important;
		color: rgba(0, 0, 0, 0) !important;
		background-color: transparent;
	}
}

.vue-video-player-controls {
	display: none !important;
}

.start-button {
	width: auto;
	height: auto;
	border: none;
	border-radius: none;
	background-color: rgba(0, 0, 0, 0) !important;
	cursor: none;
}

.vue-player-time-control {
	position: absolute;
	top: -5px;
	left: 0;
	padding-top: 0;
	color: rgba(255, 255, 255, 0.3) !important;
	display: block;
}

.button {
	width: 35px;
	border: none !important;
	color: rgba(0, 0, 0, 0) !important;
	background-color: transparent;
}

.minilinksblack {
	position: absolute;
	cursor: pointer;
	color: black;
	font-family: 'lemon_milkregular';
	font-style: italic;
	-webkit-font-smoothing: antialiased;
	font-size: 0.8em;
	z-index: 100;
	text-decoration: underline;
}

//Pg 244-245 videoWtsu
.video-content {
	.embed-responsive {
		position: absolute;
		z-index: 1000;
		width: 95%;
		height: 86%;
		top: 4.7%;
		left: 3%;
	}
}

.video-Fllts {
	.embed-responsive {
		position: absolute;
		z-index: 1000;
		width: 85.2%;
		height: 80.2%;
		top: 6.7%;
		left: 8.4%;
	}
}
</style>
